import { TypedDocumentNode, gql } from '@apollo/client';
import { faShoppingCart } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { glossary } from '@sorare/core/src/lib/glossary';
import { ClickInstantBuy_Flow } from '@sorare/core/src/protos/events/so5/shared/events';

import BuyField from 'components/buyActions/BuyField';
import PrimaryBuyBuyField from 'components/primaryBuy/PrimaryBuyBuyField';
import useGetTokenSingleSaleDetails from 'hooks/offers/useGetTokenSingleSaleDetails';
import { useIsPrimaryBuyLive } from 'hooks/primaryBuy/useIsPrimaryBuyLive';

import { BuyLowestPrice_anyCard } from './__generated__/index.graphql';

type Props = {
  card: BuyLowestPrice_anyCard;
  size: 'small' | 'medium';
  withLabel?: boolean;
  fullWidth?: boolean;
};

export const BuyLowestPrice = ({ card, size, withLabel, fullWidth }: Props) => {
  const offer = useGetTokenSingleSaleDetails(card);
  const primaryBuy = useIsPrimaryBuyLive(card);

  const buttonLabel = (
    <>
      <FontAwesomeIcon icon={faShoppingCart} size="sm" />
      {withLabel && (
        <>
          {' '}
          <FormattedMessage {...glossary.buy} />
        </>
      )}
    </>
  );
  if (offer)
    return (
      <BuyField
        card={card}
        variant={size}
        color="tertiary"
        buttonLabel={buttonLabel}
        fullWidth={fullWidth}
      />
    );

  if (primaryBuy)
    return (
      <PrimaryBuyBuyField
        size={size}
        color="tertiary"
        origin={ClickInstantBuy_Flow.SCOUTING_CENTER}
        card={card}
        cta={buttonLabel}
        fullWidth={fullWidth}
      />
    );

  return null;
};

BuyLowestPrice.fragments = {
  anyCard: gql`
    fragment BuyLowestPrice_anyCard on AnyCardInterface {
      slug
      ...useGetTokenSingleSaleDetails_anyCard
      ...useIsPrimaryBuyLive_anyCard
      ...BuyField_anyCard
      ...PrimaryBuyBuyField_anyCard
    }
    ${useIsPrimaryBuyLive.fragments.anyCard}
    ${useGetTokenSingleSaleDetails.fragments.anyCard}
    ${PrimaryBuyBuyField.fragments.anyCard}
    ${BuyField.fragments.anyCard}
  ` as TypedDocumentNode<BuyLowestPrice_anyCard>,
};
